import { render, staticRenderFns } from "./OwnerRegistration.vue?vue&type=template&id=44a94d4f"
import script from "./OwnerRegistration.vue?vue&type=script&lang=ts"
export * from "./OwnerRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./owner.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc1600359583%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fowner%2FOwnerRegistration.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./owner.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc1600359583%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fowner%2FOwnerRegistration.vue&external"
if (typeof block1 === 'function') block1(component)
import block2 from "@/views/registration/registration.fr.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc1600359583%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fowner%2FOwnerRegistration.vue&external"
if (typeof block2 === 'function') block2(component)
import block3 from "@/views/registration/registration.en.json?vue&type=custom&index=3&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc1600359583%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2Fowner%2FOwnerRegistration.vue&external"
if (typeof block3 === 'function') block3(component)

export default component.exports